// Sidebar management functions

// These functions need access to loadResearchHistory and loadPreferences
// which are defined in pre/legacy.js. We'll use function references passed via callbacks.

let loadResearchHistoryFn = null;
let loadPreferencesFn = null;

export function setSidebarCallbacks(callbacks) {
    if (callbacks.loadResearchHistory) loadResearchHistoryFn = callbacks.loadResearchHistory;
    if (callbacks.loadPreferences) loadPreferencesFn = callbacks.loadPreferences;
}

export function toggleSidebar() {
    document.getElementById('sidebar').classList.toggle('open');
}

export function openResearchHistory() {
    const sidebar = document.getElementById('researchHistorySidebar');
    const mainSidebar = document.getElementById('sidebar');
    
    // Close main sidebar if open
    if (mainSidebar && mainSidebar.classList.contains('open')) {
        mainSidebar.classList.remove('open');
    }
    
    // Close preferences sidebar if open
    const preferencesSidebar = document.getElementById('preferencesSidebar');
    if (preferencesSidebar && preferencesSidebar.classList.contains('open')) {
        preferencesSidebar.classList.remove('open');
    }
    
    // Open research history sidebar
    if (sidebar) {
        sidebar.classList.remove('hidden');
        sidebar.classList.add('open');
        // Call loadResearchHistory via callback or window.bms
        if (loadResearchHistoryFn) {
            loadResearchHistoryFn();
        } else if (typeof loadResearchHistory === 'function') {
            loadResearchHistory();
        } else if (window.bms && window.bms.loadResearchHistory) {
            window.bms.loadResearchHistory();
        }
    }
}

export function openPreferences() {
    const sidebar = document.getElementById('preferencesSidebar');
    const mainSidebar = document.getElementById('sidebar');
    
    // Close main sidebar if open
    if (mainSidebar && mainSidebar.classList.contains('open')) {
        mainSidebar.classList.remove('open');
    }
    
    // Close research history sidebar if open
    const researchSidebar = document.getElementById('researchHistorySidebar');
    if (researchSidebar && researchSidebar.classList.contains('open')) {
        researchSidebar.classList.remove('open');
    }
    
    // Open preferences sidebar
    if (sidebar) {
        sidebar.classList.remove('hidden');
        sidebar.classList.add('open');
        // Call loadPreferences via callback or window.bms
        if (loadPreferencesFn) {
            loadPreferencesFn();
        } else if (typeof loadPreferences === 'function') {
            loadPreferences();
        } else if (window.bms && window.bms.loadPreferences) {
            window.bms.loadPreferences();
        }
        
        // Re-attach event listeners for preference option chips (in case they were recreated)
        const preferenceOptionChips = document.querySelectorAll('.preference-option-chip');
        preferenceOptionChips.forEach(chip => {
            // Remove existing listeners by cloning
            const newChip = chip.cloneNode(true);
            chip.parentNode.replaceChild(newChip, chip);
            
            // Add click handler
            newChip.addEventListener('click', (e) => {
                e.preventDefault();
                // Find the parent preference-chip container
                const preferenceChip = newChip.closest('.preference-chip');
                if (preferenceChip) {
                    // Remove active class from all chips in the same preference group
                    preferenceChip.querySelectorAll('.preference-option-chip').forEach(c => c.classList.remove('active'));
                }
                // Add active class to clicked chip
                newChip.classList.add('active');
            });
        });
    }
}

export function closeResearchHistory(shouldReopenMain = false) {
    const sidebar = document.getElementById('researchHistorySidebar');
    if (sidebar) {
        sidebar.classList.remove('open');
        // Hide after transition
        setTimeout(() => {
            sidebar.classList.add('hidden');
        }, 300);
    }

    if (shouldReopenMain) {
        showMainSidebar();
    }
}

export function closePreferences(shouldReopenMain = false) {
    const sidebar = document.getElementById('preferencesSidebar');
    if (sidebar) {
        sidebar.classList.remove('open');
        // Hide after transition
        setTimeout(() => {
            sidebar.classList.add('hidden');
        }, 300);
    }

    if (shouldReopenMain) {
        showMainSidebar();
    }
}

export function showMainSidebar() {
    const researchSidebar = document.getElementById('researchHistorySidebar');
    if (researchSidebar) {
        researchSidebar.classList.remove('open');
        setTimeout(() => {
            researchSidebar.classList.add('hidden');
        }, 300);
    }
    
    const preferencesSidebar = document.getElementById('preferencesSidebar');
    if (preferencesSidebar) {
        preferencesSidebar.classList.remove('open');
        setTimeout(() => {
            preferencesSidebar.classList.add('hidden');
        }, 300);
    }

    const mainSidebar = document.getElementById('sidebar');
    if (mainSidebar) {
        mainSidebar.classList.remove('hidden');
        mainSidebar.classList.add('open');
    }
}
